import React, { useState } from 'react';
import ConfirmModal from '../../ui/ConfirmModal';
import memoryService from '../../../services/memoryService';
import Toast from '../../Toast';

const DeleteMemoryModal = ({ onClose, data, refetch }) => {
  const [loading, setLoading] = useState(false);

  const handleMemoryDelete = async () => {
    try {
      setLoading(true);
      const resp = await memoryService.deleteMemory(data?.id);
      if (resp?.success) {
        Toast({
          type: 'success',
          message: 'Memory Deleted Successfully',
        });
        onClose();
        refetch();
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error?.detail || 'Something went wrong!!!',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmModal
      title="Delete Memory"
      message="Are you sure you want to delete this memory? There is no way to recover it."
      confirmLabel={loading ? 'Deleting...' : 'Delete'}
      loading={loading}
      onConfirm={handleMemoryDelete}
      onClose={onClose}
    />
  );
};

export default DeleteMemoryModal;
